import { TApplicationState } from '../../types/redux';

export function getSpecialStatusDisplay(state: TApplicationState) {
  const {
    newbuilding: { specialStatusDisplay },
  } = state;

  return specialStatusDisplay;
}
